import type { TFunction } from "i18next";

/**
 * The `t` a helper outside React takes as an argument. Any `useTranslation()`
 * result fits it, whatever namespaces that component loaded.
 */
export type Translate = TFunction<any, any>;

/** Calls `t` with a key built at runtime, which the typed keys cannot check. */
export function translateKey(
  t: Translate,
  key: string,
  options?: Record<string, unknown>
): string {
  return String((t as (k: string, o?: object) => unknown)(key, options ?? {}));
}
